//GeneratorFlag:[NoChange]
import PersonLegal from './person-legal';

export default {PersonLegal}
export{PersonLegal}